module.exports = __webpack_public_path__ + "static/img/BUBLY_SMILE-BELLINI-BLISS.51a5f89.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/BUBLY_SMILE-BELLINI-BLISS.gif
// module id = MNQl
// module chunks = 0